import { useTranslation } from '@shared/config/i18n'
import React from 'react'
import { match } from 'ts-pattern'
import { z } from 'zod'

import { Box, Typography } from '@podo-app/design-system-temp'

import { cancelInvoiceStatusSchema, invoiceStatusSchema } from '../../model'

type Props = {
  invoiceStatus: z.infer<typeof invoiceStatusSchema>
}

export const LessonStatusByInvoiceStatus = ({ invoiceStatus }: Props) => {
  const t = useTranslation()

  return match(invoiceStatus)
    .with(invoiceStatusSchema.Enum.CANCEL_NOSHOW_T, () => (
      <React.Fragment>
        <Box className="w-px h-2 border border-gray-300" />
        <Typography size="body1" className="font-normal text-red-normal">
          {t('lesson.status.TUTOR_ABSENT')}
        </Typography>
      </React.Fragment>
    ))
    .with(invoiceStatusSchema.Enum.NOSHOW_S, () => (
      <React.Fragment>
        <Box className="w-px h-2 border border-gray-300" />
        <Typography size="body1" className="font-normal text-red-normal">
          {t('lesson.status.STUDENT_ABSENT')}
        </Typography>
      </React.Fragment>
    ))
    .when(
      (invoiceStatus) => cancelInvoiceStatusSchema.safeParse(invoiceStatus).success,
      () => (
        <React.Fragment>
          <Box className="w-px h-2 border border-gray-300" />
          <Typography size="body1" className="font-normal text-red-normal">
            {t('lesson.status.BOOKING_CANCELED')}
          </Typography>
        </React.Fragment>
      ),
    )
    .otherwise(() => null)
}
